import { Share2, MessageSquare, BarChart3, GraduationCap, Check } from "lucide-react";

const addonFeatures = [
  { icon: Share2, text: "Facebook & Instagram post scheduling" },
  { icon: MessageSquare, text: "WhatsApp customer blasts" },
  { icon: BarChart3, text: "Basic performance reports" },
];

export default function Addons() {
  return (
    <section id="addons" data-testid="addons-setup-section" className="bg-white py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#1ABC9C] bg-[#E8F8F5] px-4 py-1.5 rounded-full mb-4">Add-ons & Setup</span>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#2C3E50] max-w-2xl">
          Everything else you need to launch
        </h2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div data-testid="social-addon-card" className="rounded-2xl border-2 border-[#AED6F1] bg-[#EBF5FB] p-8">
            <span className="w-12 h-12 rounded-xl bg-[#1B4F72] flex items-center justify-center mb-5">
              <Share2 className="w-6 h-6 text-[#1ABC9C]" />
            </span>
            <h3 className="font-display text-xl sm:text-2xl font-bold text-[#2C3E50]">Social Media & Promotions Add-on</h3>
            <p className="mt-1 text-sm font-bold uppercase tracking-widest text-[#1ABC9C]">Available on request</p>
            <p className="mt-5 font-display text-2xl font-extrabold text-[#1B4F72]">Monthly or yearly</p>
            <p className="mt-1 text-sm text-[#5D6D7E]">Priced separately with a small one-time setup — ask us for details.</p>
            <ul className="mt-6 space-y-3">
              {addonFeatures.map((f, i) => (
                <li key={i} className="flex items-center gap-3">
                  <f.icon className="w-5 h-5 text-[#1B4F72] shrink-0" />
                  <span className="text-base text-[#2C3E50]">{f.text}</span>
                </li>
              ))}
            </ul>
            <a href="#contact" data-testid="addon-request-btn" className="mt-8 inline-block bg-[#1B4F72] hover:bg-[#143D59] text-white font-bold px-6 py-3.5 rounded-full transition-colors">
              Request this add-on
            </a>
          </div>
          <div data-testid="setup-fee-card" className="rounded-2xl bg-[#1B4F72] p-8 flex flex-col">
            <span className="w-12 h-12 rounded-xl bg-[#1ABC9C]/15 flex items-center justify-center mb-5">
              <GraduationCap className="w-6 h-6 text-[#1ABC9C]" />
            </span>
            <h3 className="font-display text-xl sm:text-2xl font-bold text-white">Setup & training</h3>
            <p className="mt-5 font-display text-2xl font-extrabold text-white">One-time onboarding fee</p>
            <p className="mt-1 text-sm font-medium text-[#AED6F1]">per client, once only — confirmed in your quote</p>
            <ul className="mt-6 space-y-3 flex-1">
              <li className="flex items-center gap-3">
                <Check className="w-5 h-5 text-[#1ABC9C] shrink-0" />
                <span className="text-base text-[#EBF5FB]">Full onboarding of your business</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-5 h-5 text-[#1ABC9C] shrink-0" />
                <span className="text-base text-[#EBF5FB]">Hands-on staff training — your team will be confident from day one</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-5 h-5 text-[#1ABC9C] shrink-0" />
                <span className="text-base text-[#EBF5FB]">Your services, prices and branding configured for you</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
